import { Inject, Injectable } from '@angular/core';


@Injectable()
export class AppConfigService {

    public host = '';
    public token = localStorage.getItem('auth-key');
    public url: string;

    constructor() {
        const hostname: string = window.document.location.hostname;

        // intuit from the document loading is whether this is dev or prod environment
        if (hostname === 'localhost') {
          this.host = 'http://localhost:3501';
        } else {
          this.host = 'https://jc-api.positronic.ai';
        }

        this.url = `${this.host}/api`;
        console.log(`api-host=${this.host}`);
      }
}



// WEBPACK FOOTER //
// ./src/app/app.config.ts